var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderSaleReceipt',{attrs:{"img_header":_vm.header_image,"header":"แก้ไขใบเสร็จ (Modify receipt)","link_back":"salemain/salereceiptretail"}}),_c('Edit_receipt_retail_vip')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }